<template>
  <svg
    id="zoom"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 487.3 487.3"
    style="enable-background:new 0 0 487.3 487.3;"
    xml:space="preserve"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="16"
      stroke-miterlimit="10"
      d="M358,183c0,96.6-78.4,175-175,175S8,279.6,8,183S86.4,8,183,8S358,86.4,358,183"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="16"
      stroke-miterlimit="10"
      d="M481.7,481.7L306.8,306.8"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="16"
      stroke-miterlimit="10"
      d="M288,183H78"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="16"
      stroke-miterlimit="10"
      d="M183,288V78"
    />
  </svg>
</template>